/* import __COLOCATED_TEMPLATE__ from './successful-bank-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();